const cooperationCaseRouter = {
  route: null,
  name: null,
  title: '合作案例管理',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont icon-tushuguanli',
  filePath: 'view/cooperation-case/', // 文件路径
  order: null,
  inNav: true,
  children: [
    {
      title: '添加合作案例',
      type: 'view',
      name: 'CooperationCaseCreate',
      route: '/cooperation-case/add',
      filePath: 'view/cooperation-case/cooperation-case-create.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
    {
      title: '合作案例列表',
      type: 'view',
      name: 'CooperationCase',
      route: '/cooperation-case/list',
      filePath: 'view/cooperation-case/cooperation-case-list.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
  ],
}

export default cooperationCaseRouter
